import React, { useEffect, useState } from "react";

import { UserFields } from "types/admin/UserFields";
import { ProjectFields_users_items } from "types/admin/ProjectFields";

import { Button } from "../Button";

import { Table, TableContainer } from "../Table";

import { DataTableBody, DataTableCell, DataTableContent, DataTableRow } from "@rmwc/data-table";
import "@rmwc/data-table/styles";

import { ListItemPrimaryText, ListItemSecondaryText, ListItemText } from "@rmwc/list";
import "@rmwc/list/styles";

import { MenuItem, SimpleMenu } from "@rmwc/menu";
import "@rmwc/menu/styles";

import Palette from "../../palette.json";
import { ProjectRole } from "types/admin/globalTypes";
import { PROJECT_ROLE_TO_LABEL } from "../../common";
import { TemplateFields_users_items } from "types/admin/TemplateFields";

interface ProjectUserListPropsT {
  items: UserFields[];

  assigned: ProjectFields_users_items[] | TemplateFields_users_items[];

  onAssignUser(role: ProjectRole | null, user: UserFields): void;
  onRemoveUser(user: UserFields): void;
}

export const ProjectUserAssignList: React.FC<ProjectUserListPropsT> = ({
  items,
  assigned,
  onAssignUser,
  onRemoveUser,
}) => {
  const [userRoles, setUserRoles] = useState<(ProjectRole | null)[]>([]);

  useEffect(() => {
    if (userRoles.length > 0) return; // make sure this only runs on page load for initial data

    const roles: (ProjectRole | null)[] = items.map((user) => {
      return user.projectRole;
    });

    setUserRoles(roles);
  }, [items]);

  return (
    <TableContainer>
      <Table>
        <DataTableContent>
          <DataTableBody>
            {!items.length && (
              <DataTableRow>
                <DataTableCell colSpan={3} style={{ color: Palette.LightGrey, fontSize: "18px", textAlign: "center" }}>
                  - No People -
                </DataTableCell>
              </DataTableRow>
            )}
            {items.map((it, i) => (
              <DataTableRow key={i}>
                <DataTableCell>
                  <ListItemText>
                    <ListItemPrimaryText style={{ marginTop: "-20px" }}>{it.name}</ListItemPrimaryText>
                    <ListItemSecondaryText>{it.email}</ListItemSecondaryText>
                  </ListItemText>
                </DataTableCell>
                <DataTableCell>
                  <SimpleMenu
                    anchorCorner="bottomStart"
                    focusOnOpen={false}
                    onSelect={(ev) => {
                      const roles: (ProjectRole | null)[] = [...userRoles];
                      roles[i] = [
                        ProjectRole.manager,
                        ProjectRole.technician,
                        ProjectRole.technicianInspector,
                        ProjectRole.customer,
                      ][ev.detail.index];
                      setUserRoles(roles);
                    }}
                    handle={
                      <Button outlined trailingIcon="unfold_more">
                        {userRoles[i]
                          ? PROJECT_ROLE_TO_LABEL[userRoles[i] || ProjectRole.technician]
                          : "-- Select Role --"}
                      </Button>
                    }
                  >
                    <MenuItem>Manager</MenuItem>
                    <MenuItem>Technician</MenuItem>
                    <MenuItem>Inspector</MenuItem>
                    <MenuItem>Customer</MenuItem>
                  </SimpleMenu>
                </DataTableCell>
                <DataTableCell>
                  <Button
                    style={{ width: "7rem" }}
                    outlined={!(assigned as any).find((jt) => jt.userId === it.id)}
                    raised={!!(assigned as any).find((jt) => jt.userId === it.id)}
                    onClick={() =>
                      (assigned as any).find((jt) => jt.userId === it.id)
                        ? onRemoveUser(it)
                        : onAssignUser(userRoles[i], it)
                    }
                  >
                    {!!(assigned as any).find((jt) => jt.userId === it.id) ? "Assigned" : "Assign"}
                  </Button>
                </DataTableCell>
              </DataTableRow>
            ))}
            <div style={{ height: "200px" }}></div>
          </DataTableBody>
        </DataTableContent>
      </Table>
    </TableContainer>
  );
};
